import React, { useEffect, useRef, useState } from 'react';
import setUiMessage from '../../Utilities/Tostify';
import { post } from '../Auths/AuthToken';
import { debounce } from 'lodash';
import { Link } from 'react-router-dom';

function ComPatSearch({
  defaultPat,
  msgType,
  bigSearchBox,
  fieldName,
  changeShow = false,
  handlePatArr,
  returntype = 'array',
  intakePatSrch = false,
}) {
  const [input, setInput] = useState('');
  const [isDivHidden, setIsDivHidden] = useState(false);
  const [selectedPats, setSelectedPats] = useState(
    defaultPat && defaultPat.length > 0 ? [...defaultPat] : []
  );
  const [patList, setPatList] = useState([]);
  const inputRef = useRef();

  // Effect to handle the selected patients based on return type
  useEffect(() => {
    if (returntype === 'str') {
      handlePatArr(selectedPats.map((item) => item?.userId).join(','));
    } else {
      handlePatArr(selectedPats);
    }
  }, [selectedPats, handlePatArr, returntype]);

  // Effect to handle clicks outside the input field
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setIsDivHidden(true);
      } else {
        setIsDivHidden(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    let isCancelled = false;

    const debouncedFetchResults = debounce(async (term) => {
      try {
        const response = await post(
          'api/appointment/appointment/listOfPatient',
          {
            searchStr: input,
            searchCritaria: 'any',
          }
        );

        if (!isCancelled && response.status === 200) {
          setIsDivHidden(false);
          setPatList(response?.data?.patList || []);
        }
      } catch (err) {
        setUiMessage('suc', err.message);
      } finally {
        //setIsDivHidden(false);
      }
    }, 500);

    if (input.trim() !== '') {
      debouncedFetchResults(input);
    } else {
      setPatList([]);
    }

    return () => {
      isCancelled = true;
      debouncedFetchResults.cancel(); // Cancel any pending debounce on cleanup
    };
  }, [input]);

  // Function to handle deletion of selected patient
  const handlePatDelete = (patIndex) => {
    const updateSelectedPats = [...selectedPats];
    updateSelectedPats.splice(patIndex, 1);
    setSelectedPats(updateSelectedPats);
  };

  // Function to handle selection of a patient
  const handleSelectedPat = (pat) => {
    if (msgType === 'mobile') {
      if (pat?.mobile) {
        if (selectedPats.some((item) => item.userId === pat.userId)) {
          setUiMessage('err', 'Patient already added!');
        } else {
          setSelectedPats([...selectedPats, pat]);
          setInput('');
        }
        //setInput('');
      } else {
        setUiMessage('inf', 'Mobile number not available.');
      }
    } else if (msgType === 'email') {
      if (pat?.email) {
        if (selectedPats.some((item) => item.userId === pat.userId)) {
          setUiMessage('err', 'Patient already added!');
        } else {
          setSelectedPats([...selectedPats, pat]);
          setInput('');
        }
        //setInput('');
      } else {
        setUiMessage('inf', 'E-mail not available.');
      }
    } else {
      if (selectedPats.some((item) => item.userId === pat.userId)) {
        setUiMessage('err', 'Patient already added!');
      } else {
        setSelectedPats([...selectedPats, pat]);
        setInput('');
      }
    }
  };

  // Render the component
  return (
    <>
      <div
        ref={inputRef}
        className="comp-msg-bdy-rw grid-sec"
        style={{ position: 'relative' }}
      >
        {/* Input field for patient search */}
        <div className="comp-msg-bdy-chld-rw flex-sec">
          {fieldName && <span className="msg-bdy-rw-bl">{fieldName}:</span>}
          {bigSearchBox ? (
            <span className="msg-bdy-rw-val">
              <input
                type="search"
                className="msg-inpt"
                placeholder="Search Patient"
                onChange={(e) => setInput(e.target.value)}
                value={input}
              />
            </span>
          ) : (
            <span className="msg-bdy-rw-val">
              <input
                type="search"
                className="msg-inpt"
                placeholder="Search patient..."
                style={{ width: '50%' }}
                onChange={(e) => setInput(e.target.value)}
                value={input}
              />
              <span className="msg-bx-sep" style={{ margin: '0px 20px' }}>
                |
              </span>
              <Link href="" style={{ fontSize: '14px' }}>
                Patient list
              </Link>
            </span>
          )}
        </div>

        {/* Display search results */}
        {patList.length > 0 && (
          <div
            className={`search-user-pnl grid-sec qhide ${
              isDivHidden ? 'hide' : ''
            }`}
            // style={{ top: '-143px' }}
          >
            {patList
              ? patList.map((data, idx) => {
                  return (
                    <div
                      key={idx}
                      className={`${
                        selectedPats.some((obj) => obj.userId === data.userId)
                          ? `usr-name grid-sec pat-rec-selected`
                          : `usr-name grid-sec`
                      }`}
                      onClick={() => handleSelectedPat(patList[idx])}
                    >
                      {/* Patient details */}
                      <div className="">
                        <span className="name">
                          {data?.passPaientNameInJsFun}
                        </span>
                        <span className="msg-bx-sep">|</span>
                        <span className="name">DOB: {data?.dob}</span>
                        <span className="msg-bx-sep">|</span>
                        <span className="name">
                          {data?.age} [{data?.gender.toUpperCase().substr(0, 1)}
                          ]
                        </span>
                        <span className="msg-bx-sep">|</span>
                        <span className="name">
                          Chart ID: {data?.chart_number.toUpperCase()}
                        </span>
                        {intakePatSrch && (
                          <span>
                            <span className="msg-bx-sep">|</span>
                            <span className="name">
                              Mobile: {data?.mobile || ''}
                            </span>
                            <span className="msg-bx-sep">|</span>
                            <span className="name">
                              Email: {data?.email || ''}
                            </span>
                          </span>
                        )}
                      </div>
                      {msgType && (
                        <div className={`clear-top5 sec-colr`}>
                          <span className="name">M:&nbsp;</span>
                          <span className="name">{data?.mobile}</span>
                          <span className="msg-bx-sep">|</span>
                          <span className="name">Email:&nbsp;</span>
                          <span className="name">{data?.email}</span>
                          {/* Change option (if applicable) */}
                          <span
                            className={`${
                              changeShow
                                ? `name com-edit right`
                                : `name com-edit right hide`
                            }`}
                          >
                            [Change]
                          </span>
                        </div>
                      )}
                    </div>
                  );
                })
              : ''}
          </div>
        )}

        {/* Display selected patients */}
        <div
          className={
            selectedPats.length !== 0
              ? `comp-msg-bdy-chld-rw flex-sec`
              : `comp-msg-bdy-chld-rw flex-sec hide`
          }
          style={{ marginTop: '5px' }}
        >
          {fieldName && <div className="msg-bdy-rw-bl">&nbsp;</div>}
          <div
            className="msg-bdy-rw-val atchd-ptnt-col flex-sec "
            style={{ flexFlow: 'wrap' }}
          >
            {selectedPats
              ? selectedPats.map((data, idx) => {
                  return (
                    <div
                      key={idx}
                      className="msg-chld-rw-atchd-ptnt flex-sec slctd-name"
                    >
                      {/* Display selected patient details */}
                      <div className="slctd-name grid-sec">
                        <span className="name">
                          {data?.passPaientNameInJsFun}
                        </span>
                        {(msgType === 'mobole' && (
                          <span className="name">{data?.mobile}</span>
                        )) ||
                          (msgType === 'email' && (
                            <span className="name">{data?.email}</span>
                          )) ||
                          ''}
                      </div>
                      {/* Remove option */}
                      <div
                        className="slctd-name-rmv"
                        onClick={() => handlePatDelete(idx)}
                      >
                        X
                      </div>
                    </div>
                  );
                })
              : ''}
          </div>
        </div>
      </div>
    </>
  );
}

export default ComPatSearch;
